module.exports = __webpack_public_path__ + "static/media/sidebar_2.1753a9d0.png";